const productTabsData = {
  allergens: [
    { title: 'Eggs and their derivates', value: 'No' },
    { title: 'Fish and their derivates', value: 'No' },
    { title: "Milk and it's derivates", value: 'Yes' },
    { title: 'Nuts and their derivates', value: 'No' },
    { title: 'Peanuts and their derivates', value: 'No' },
    { title: 'Soybeans and their derivates ', value: 'No' },
    { title: "Wheat and it's derivates", value: 'No' },
  ],
  nutritionList: [
    'Ready-to-drink nutrition shake',
    'Suitable for lactose intolerance',
    'Source of protein',
    '0 g trans fat',
    'Contains milk, soy, and their derivate',
    'Gluten free',
  ],
  nutritionFacts: [
    { title: 'Calories', value: '70kcal' },
    { title: 'Calories from Fat	', value: '15kcal' },
    { title: 'Transfatty Acids', value: '0g' },
    { title: 'Saturated Fat', value: '0g' },
    { title: 'Cholesterol', value: '0mg' },
    { title: 'Sodium', value: '55mg' },
    { title: 'Sodium RDI', value: '2%' },
    { title: 'Carbohydrate', value: '13g' },
    { title: 'Carbohydrate RDI', value: '4.33%' },
    { title: 'Protein', value: '2g' },
  ],
  nutritionFacts2: [
    { title: 'Calories', value: '2,000' },
    { title: 'Calories from Fat	', compare: 'Less than', value: '65g' },
    { title: 'Transfatty Acids', compare: 'Less than', value: '20g' },
    { title: 'Cholesterol', compare: 'Less than', value: '300mg' },
    { title: 'Sodium', compare: 'Less than', value: '2,400mg' },
    { title: 'Total Carbohydrate', value: '300g' },
    { title: 'Dietary Fiber', value: '25g' },
  ],
}

export default productTabsData
